export default class ParentsAPI {
  private services: any;

  constructor(services) {
    this.services = services;
  }

  public getCoursesSummary({ parentID }) {
    return this.services.baseAPI
      .get(`/parents/courses?parentid=${parentID}`, false);
  }

  public getChildren(parentID) {
    return this.services.baseAPI
      .get(`/parents/${parentID}/children`, false);
  }

  public getCourseDetails({ parentID, courseID }) {
    return this.services.baseAPI
      .get(`/parents/course/details?parentid=${parentID}&courseid=${courseID}`, false);
  }

  public makePayment(item) {
    return this.services.baseAPI.post(`users/parents/make_payment`, item, false);
  }

  public addChild(item) {
    return this.services.baseAPI.post(`parents/subscription/add_learner`, item);
  }

  public switchSubscriptionPackage(item) {
    return this.services.baseAPI.post(`users/parents/switch_package`, item);
  }
  public cancelSubscription() {
    return this.services.baseAPI.post(`users/parents/cancel_subscription`);
  }

  public registerMarketingParents(item) {
    return this.services.baseAPI.post(`users/registration/marketing_parents`, item, true);
  } 
}



// WEBPACK FOOTER //
// ./src/services/API/v1/Parents.ts